import { ProcessedVolumeDiscountThreshold } from '@app/data/clients/rbServerSideClient/queries/GetSearchResults/types';
import Alert from '@redbubble/design-system/src/Alert';
import Box from '@redbubble/design-system/src/Box';
import * as constants from '@redbubble/design-system/src/constants';
import Text from '@redbubble/design-system/src/Text';
import { FormattedMessage } from '@redbubble/next/intl';
import styles from './VolumeDiscountBanner.module.scss';

interface VolumeDiscountBannerProps {
  volumeDiscountThresholds: ProcessedVolumeDiscountThreshold[] | null;
}

export const VolumeDiscountBanner = ({
  volumeDiscountThresholds,
}: VolumeDiscountBannerProps) => {
  if (!volumeDiscountThresholds) return null;

  return (
    <Box marginBottom="m" data-testid="volume-discount-banner">
      <Alert intent={constants.INFORMATION} label={false}>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          flexWrap="wrap"
          justifyContent="center"
          className={styles.bannerContainer}
        >
          {volumeDiscountThresholds.map(({ quantity, percentOff }) => (
            <Text type="body" key={`volume-discount-${quantity}`}>
              <strong>
                <FormattedMessage
                  defaultMessage="Buy any {quantity} and get {percentOff}% off."
                  values={{ quantity, percentOff }}
                />
              </strong>
            </Text>
          ))}
        </Box>
      </Alert>
    </Box>
  );
};
